<meta itemprop="url" content="{{ meta.contentUrl }}"/>
<meta itemprop="name" content="{{ meta.fullTitle }}"/>
<meta itemprop="datePublished" content="{{ meta.contentDate?.toISOString() }}"/>
<meta itemprop="image" content="{{ meta?.metaImageUrl || meta?.coverImageUrl }}"/>
<meta *ngIf="meta?.description" itemprop="description" content="{{ meta?.description | striptags }}"/>
<meta itemprop="headline" content=""/>
<!-- <meta itemprop="publisher" content="htts://onclass.com"/> -->
<!-- keywords -->
<meta itemprop="inLanguage" content="{{ meta?.languageCode }}"/>
<!-- discussionUrl -->
<meta *ngIf="meta?.commentsCount" itemprop="commentCount" content="{{ meta?.commentsCount }}"/>
